import { render, staticRenderFns } from "./collapsible-card.vue?vue&type=template&id=52f1995e&scoped=true&lang=pug&"
import script from "./collapsible-card.vue?vue&type=script&lang=ts&"
export * from "./collapsible-card.vue?vue&type=script&lang=ts&"
import style0 from "./collapsible-card.vue?vue&type=style&index=0&id=52f1995e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f1995e",
  null
  
)

export default component.exports